import React, { useEffect, useState } from "react";
import Img1 from "../assets/images/hero/transforming-india.png";
import Bg1 from "../assets/images/bg/bg1.png";
import { Link } from "react-router-dom";
import HeroCarousel from "../components/carousel/HeroCarousel";
import FeatureSection from "../components/FeatureSection";
import ScrollFeatureSection from "../components/ScrollFeatureSection";
import FlipCardSlider from "../components/Slider/FlipCardSlider";
import CardSlider from "../components/Slider/CardSlider";
import GSAPFeatureSection from "../components/GSAPFeatureSection";
import NewFeatures from "../components/NewFeatures";
import VisionImg from "../assets/32.svg";
import ViewImg from "../assets/33.png";
import AnimatedCarousel from "../components/carousel/AnimatedCarousel";
import Card from "../components/Card/Card";
import CardContainer from "../components/Card/CardContainer";
import GSAPProductReveal from "../components/Product/GSAPProductReveal";
import ProductSlider from "../components/Product/ProductSlider";
import Testimonials from "../components/Testimonials/Testimonials";
import Page from "../layout/Page";
import BrandLogoStrip from "../components/Slider/BrandLogoStrip";
import axios from "axios";

// const relatedBlogs = [
//   {
//     contentType: "blog",
//     title: "Envisioning the Future of Mobility with Shoora",
//     description:
//       "Shoora offers comprehensive fleet management solutions that track vehicle locations, monitor driver performance, optimise routes, and reduce fuel consumption.",
//     thumbnail: "/images/thumbnails/14.jpeg",
//     link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
//     readTime: 10,
//   },
//   {
//     contentType: "blog",
//     title: "Leverage AIS-140’s Mandate for Telematics Devices",
//     description:
//       "Shoora, a leader in advanced video telematics solutions , is committed to harnessing the potential of this mandate to create safer roads and smarter transportation systems.",
//     thumbnail: "https://www.easyembedded.net/images/ais2.jpg",
//     link: "/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles",
//     readTime: 10,
//   },
//   {
//     contentType: "blog",
//     title: "Tackling Distracted Driving: Transforming Fleet Safety",
//     description:
//       "By adopting the Three Ts—Talk, Train, and Track, Shoora addresses distracted driving head-on, protecting lives and optimising operations.",
//     thumbnail: "/images/thumbnails/3.jpeg",
//     link: "/insights/blog/tackling-distracted-driving-transforming-fleet-safety",
//     readTime: 10,
//   },
//   {
//     contentType: "blog",
//     title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
//     description:
//       "Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives.",
//     thumbnail:
//       "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
//     link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
//     readTime: 10,
//   },
//   {
//     contentType: "customer story",
//     title: "Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
//     description:
//       "Shoora is not just a service provider for BLR Logistics; they are a trusted safety partner.",
//     thumbnail:
//       "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
//     link: "/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents",
//     readTime: 10,
//   },

//   {
//     contentType: "customer story",
//     title: "Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres",
//     description:
//       "The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings.",
//     thumbnail: "/images/thumbnails/15.jpeg",
//     link: "/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions",
//     readTime: 10,
//   },
// ];

const Home = () => {
  const [latestInsights, setLatestInsights] = useState([]);
  const heroSlides = [
    {
      bg: "images/hero/2.webp",
      mbg: "images/hero/2-m.webp",
      // textImg: "images/hero/text1.webp",
      buttonText: "Learn More",
      buttonLink: "/solutions/fleet-sense",
    },
    {
      bg: "images/hero/3.webp",
      mbg: "images/hero/3-m.webp",
      // textImg: "images/hero/text2.webp",
      buttonText: "Learn More",
      buttonLink: "/solutions/happy-driver-programme",
    },
    {
      bg: "images/hero/5.webp",
      mbg: "images/hero/5-m.webp",
      // textImg: "images/hero/text3.webp",
      buttonText: "Learn More",
      buttonLink: "/solutions/road-sense",
    },
  ];

  const features = [
    {
      title: "Smoking Warning",
      description:
        "Detects when the driver is smoking and issues an audio warning",
      videoSrc: "http://shoora.com/video/Smoking.mp4",
      backgroundImage:
        "https://cdn.pixabay.com/photo/2016/11/21/16/37/loader-1846346_1280.jpg",
    },
    {
      title: "Driver Posture Warning",
      description:
        " Reminds drivers to stay focused when they become distracted by detecting wrong posture",
      videoSrc: "http://shoora.com/video/Distraction.mp4",
      backgroundImage:
        "https://cdn.pixabay.com/photo/2017/11/05/14/01/truck-2920533_1280.jpg",
    },
    {
      title: "Frontal Collision Alert",
      description: "Alerts drivers to potential forward collisions",
      videoSrc: "http://shoora.com/video/Car-Close-Distance.mp4",
      backgroundImage:
        "https://cdn.pixabay.com/photo/2019/08/15/17/56/production-4408573_1280.jpg",
    },
    {
      title: "Mobile Usage Alert",
      description: "Encourages drivers to put down their phones while driving",
      videoSrc: "http://shoora.com/video/FCW.mp4",
      backgroundImage:
        "https://cdn.pixabay.com/photo/2023/01/07/11/54/quarries-7703098_1280.jpg",
    },
    {
      title: "Proximity Alert",
      description:
        "Detects and trains drivers who follow other vehicles too closely",
      videoSrc: "http://shoora.com/video/FCW.mp4",
      backgroundImage:
        "https://cdn.pixabay.com/photo/2023/01/07/11/54/quarries-7703098_1280.jpg",
    },
    {
      title: "Driver Attention Monitoring",
      description:
        "Reminds drivers to stay focused and keep their eyes on the road",
      videoSrc: "http://shoora.com/video/FCW.mp4",
      backgroundImage:
        "https://cdn.pixabay.com/photo/2023/01/07/11/54/quarries-7703098_1280.jpg",
    },
  ];

  const fetchLatestInsights = async () => {
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_API_BASE_URL}/api/insights/latest`
      );
      if (res?.status === 200) {
        // console.log("Latest Insights: ", res?.data);
        if (Array.isArray(res?.data)) {
          setLatestInsights(res?.data);
        } else {
          console.error("Data is not an array:", data);
        }
        
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchLatestInsights();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <Page
      title="Shoora | Fleet Safety"
      description="Shoora is a cutting-edge technology and mobility solutions company that helps fleet owners detect risk and protect their fleets."
      keywords="shoora, telematics, fleet safety, cabin alerts, cabin vision, cabin view, happy driver programme"
    >
      <HeroCarousel slides={heroSlides} />

      <div className="brands-strip">
        <BrandLogoStrip />
      </div>

      <div className="about-section section-gradient-animation section">
        <div className="about-content">
          <h1 className="content-scale">
            Shoora is a next-generation technology and mobility solutions
            company helping fleet owners{" "}
            <i>detect risk and protect their fleets.</i>
          </h1>
        </div>
      </div>

      {latestInsights?.length ?
        <div className="stories-section section" style={{ maxWidth: "100%" }}>
          <div className="container">
            <FlipCardSlider data={latestInsights} />
          </div>
        </div> : null
      }
      <div className="testimonials-section section">
        <div className="container">
          <Testimonials />
        </div>
      </div>
      <div className="impact-section section">
        <div className="container">
          <div className="section-header-center">
            <h2>
              Reduce accidents and insurance costs of your fleet operations
              through cutting-edge technologies such as <br />{" "}
              <i>
                Artificial Intelligence (AI), machine learning (ML), and the
                Internet of Things (IoT)
              </i>
              .
            </h2>
          </div>
          <div className="analytics-container">
            <div className="analytics-card interactive-element">
              <h3>1.2 Million</h3>
              <p>Killed each year in road accidents globally</p>
            </div>
            <div className="analytics-card interactive-element">
              <h3>50 Million</h3>
              <p>Injured on roads by vehicles annually</p>
            </div>
            <div className="analytics-card interactive-element">
              <h3>518 Billion</h3>
              <p>Cost of accidents to the global economy</p>
            </div>
          </div>
        </div>
      </div>

      <div className="product-features-section">
        <NewFeatures features={features} />
      </div>

      <div className="resources-section">
        <div className="container">
          <CardSlider />
        </div>
      </div>
    </Page>
  );
};

export default Home;
